module.exports = __webpack_public_path__ + "img/wh3.08a762e8.png";